import { Injectable } from '@angular/core';

import { DialogService } from '@mode/shared/ui';
import { UploadSheetDialogComponent, UploadSheetDialogData } from './upload-sheet-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class UploadSheetDialogService {
  readonly MODAL_ID = 'mode-upload-sheet-dialog';
  readonly MODAL_WIDTH = 1102;

  constructor(private _dialogService: DialogService) {}

  open({ confirmAction }: UploadSheetDialogData) {
    const dialogExists = this._dialogService.getDialogById(this.MODAL_ID);
    if (!dialogExists) {
      const emailAdminDialogRef = this._dialogService.open<UploadSheetDialogComponent>({
        component: UploadSheetDialogComponent,
        matDialogConfig: {
          id: this.MODAL_ID,
          minHeight: '256px',
          width: `${this.MODAL_WIDTH}px`,
        },
      });

      const confirmActionSubscription = emailAdminDialogRef.componentInstance.create.subscribe((formData) => {
        if (confirmAction) {
          confirmAction(formData);
        }
        confirmActionSubscription.unsubscribe();
      });

      return emailAdminDialogRef.afterClosed();
    }

    return undefined;
  }
}
